import type { Condition } from "@/types";

/**
 * Defines what Roboto resources can query files.
 */
export type FilesQueryScope =
  { type: "collection"; id: string } | { type: "org" };

export function filesScopeToCondition(
  scope: FilesQueryScope,
): Condition | undefined {
  switch (scope.type) {
    case "collection":
      return {
        field: "collection.collection_id",
        comparator: "EQUALS",
        value: scope.id,
      };
    case "org":
      return undefined;
  }
}
